module.exports = __webpack_public_path__ + "img/kuangjiao_xc4.bde75414.jpg";